<template>
  <div class="bg-light-grey-600 notification__popup" :class="popupDynamicClass">
    <div class="gp_modal-close p-1 notification__close" @click="closePopup">
      <i class="icon icon-cancel"></i>
    </div>
    <div v-if="notification.img_url && notification.img_url != ''" class="notification__img">
      <img :src="notification.img_url" />
    </div>
    <div :class="containerDynamicClass">
      <h2
        class="heading-h2-24-semi"
        v-html="title"
        :class="titleDynamicClass"
      ></h2>
      <p
        class="body-14-regular text-dark-subtext2 mt-4px mb-2"
        :class="timeDynamicClass"
        v-if="!isWelcomePopup && !isExtendTrial"
      >
        {{ timeago }}
      </p>
      <div v-if="isWelcomePopup">
        <p class="paragraph-14-regular txt-dark-high-contrast mb-2 mt-3">
          {{ $t("pricing.welcomePopupContent") }}
        </p>
        <a
          class="txt-primary-300 txt-primary-200-hover"
          target="_blank"
          href="https://help.gempages.net/release-note"
        >
          {{ $t("pricing.releaseNoteLink") }}
        </a>
      </div>
      <div v-else v-html="notiContent"></div>
    </div>
  </div>
</template>

<script>
import getLocale from "@/mixins/getLocale.js";
import { mapGetters } from "vuex";
import { TimeMaker } from "@/plugins";

export default {
  name: "NotificationPopup",
  mixins: [getLocale],
  props: {
    notification: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapGetters("account", {
      language: "displayLanguage",
    }),
    title() {
      return this.getLocaleText(this.notification.title);
    },
    timeago() {
      return new TimeMaker(this.notification.base_created).ago(this.language);
    },
    hasTags() {
      return this.notification.is_important;
    },
    timeDynamicClass() {
      return {};
    },
    notiContent() {
      return this.getLocaleText(this.notification.content);
    },
    isWelcomePopup() {
      return this.notification.action == "welcome_back";
    },
    isExtendTrial() {
      return !!this.notification.settings["extend-trial"];
    },
    popupDynamicClass() {
      return {
        "extend-trial": this.isExtendTrial,
      };
    },
    containerDynamicClass() {
      return {
        "pt-3 pb-4 px-5": !this.isExtendTrial,
        "p-4 pb-5": this.isExtendTrial,
      };
    },
    titleDynamicClass() {
      return {
        "mb-2": this.isExtendTrial,
        "color-red-300": this.notification.settings["extend-trial"] <= 3 && this.isExtendTrial
      };
    },
  },
  methods: {
    closePopup() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss">
$accent-red-300: #f44336;

.notification {
  &__popup {
    position: relative;
    max-width: 640px;
    min-height: 100%;

    &.extend-trial {
      max-width: 480px;
    }
  }
  &__upgrade {
    &-btn {
      width: 100%;
      &:hover {
        background-color: map-get($primary, "200");
      }
    }
  }
}

.color {
  &-red-300 {
    color: $accent-red-300;
  }
}
</style>
